import {
  faAngleLeft,
  faAngleRight,
  faArrowLeft,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const SliderContainerOuter = styled.section`
  position: relative;
  width: 100%;
  height: 600px;
  overflow: hidden;
  @media only screen and (max-width: 600px) {
    height: 200px;
  }
`;

const SliderContainer = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  transition: transform 0.5s ease-in-out;
`;

const SliderControlButton = styled.section`
  width: 50px;
  height: 50px;
  background: ${({ landingPrimaryColor }) => landingPrimaryColor};
  border-radius: 50%;
  cursor: pointer;
  color: #fff;
  font-size: 26px;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.4s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background: ${({ landingSecondaryColor }) => landingSecondaryColor};
  }
  &.prev {
    left: 10px;
  }
  &.next {
    right: 10px;
  }
  @media only screen and (max-width: 600px) {
    width: 30px;
    height: 30px;
    font-size: 20px;
  }
`;

const SlideContainer = styled.section`
  width: 100%;
  height: 100%;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  h1 {
    max-width: 500px;
    position: absolute;
    top: 20%;
    left: 19%;
    z-index: 99999;
    color: rgb(44, 45, 63);
    font-size: 38px;
    font-weight: 700;
    margin: 0px;
    padding: 0px;
    line-height: 60px;
  }
  @media only screen and (max-width: 600px) {
    h1 {
      max-width: 50%;
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

const Highlite = styled.span`
  color: ${({ landingPrimaryColor }) => landingPrimaryColor};
`;

const ImageSlider = ({ landingPrimaryColor, landingSecondaryColor }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [index, setIndex] = useState(0);
  const totalSlides = 4;
  const sliderRef = useRef(null);

  const nextSlide = () => {
    setIndex((prevIndex) => (prevIndex + 1) % totalSlides);
  };

  const prevSlide = () => {
    setIndex((prevIndex) => (prevIndex - 1 + totalSlides) % totalSlides);
  };

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <SliderContainerOuter>
      <SliderContainer
        ref={sliderRef}
        style={{
          width: `${width * totalSlides}px`,
          transform: `translateX(-${index * width}px)`,
        }}
      >
        <SlideContainer>
          <img src="/img/sliders/01.png" alt="Slide" />
          <div class="container">
            <h1>
              Instant Recharge, Anytime, Anywhere – Top Up Your{' '}
              <Highlite landingPrimaryColor={landingPrimaryColor}>
                Mobile
              </Highlite>
              ,{' '}
              <Highlite landingPrimaryColor={landingPrimaryColor}>DTH</Highlite>
              , and{' '}
              <Highlite landingPrimaryColor={landingPrimaryColor}>
                More
              </Highlite>{' '}
              with Just a Click
            </h1>
          </div>
        </SlideContainer>
        <SlideContainer>
          <img src="/img/sliders/02.png" alt="Slide" />
          <div class="container">
            <h1>
              <Highlite landingPrimaryColor={landingPrimaryColor}>
                Secure
              </Highlite>{' '}
              and{' '}
              <Highlite landingPrimaryColor={landingPrimaryColor}>
                Hassle-Free
              </Highlite>{' '}
              Payments – Transact Safely with Our{' '}
              <Highlite landingPrimaryColor={landingPrimaryColor}>
                Trusted
              </Highlite>{' '}
              Portal
            </h1>
          </div>
        </SlideContainer>
        <SlideContainer>
          <img src="/img/sliders/03.png" alt="Slide" />
          <div class="container">
            <h1>
              Get Exclusive{' '}
              <Highlite landingPrimaryColor={landingPrimaryColor}>
                Discounts
              </Highlite>{' '}
              and{' '}
              <Highlite landingPrimaryColor={landingPrimaryColor}>
                Rewards
              </Highlite>{' '}
              on Every Recharge –{' '}
              <Highlite landingPrimaryColor={landingPrimaryColor}>
                Save More
              </Highlite>{' '}
              with Every Transaction
            </h1>
          </div>
        </SlideContainer>
        <SlideContainer>
          <img src="/img/sliders/04.png" alt="Slide" />

          <div class="container">
            <h1>
              <Highlite landingPrimaryColor={landingPrimaryColor}>
                24/7 Availability
              </Highlite>{' '}
              – No More Waiting in Line,{' '}
              <Highlite landingPrimaryColor={landingPrimaryColor}>
                Recharge
              </Highlite>{' '}
              Your Services at Your{' '}
              <Highlite landingPrimaryColor={landingPrimaryColor}>
                Convenience
              </Highlite>
            </h1>
          </div>
        </SlideContainer>
      </SliderContainer>
      <SliderControlButton
        className="prev"
        landingPrimaryColor={landingPrimaryColor}
        landingSecondaryColor={landingSecondaryColor}
        onClick={prevSlide}
      >
        <FontAwesomeIcon icon={faAngleLeft} />
      </SliderControlButton>
      <SliderControlButton
        className="next"
        landingPrimaryColor={landingPrimaryColor}
        landingSecondaryColor={landingSecondaryColor}
        onClick={nextSlide}
      >
        <FontAwesomeIcon icon={faAngleRight} />
      </SliderControlButton>
    </SliderContainerOuter>
  );
};

export default ImageSlider;
